var App = App || {};

App.ComponentAccordion = (function ($) {
    'use strict';

    function ShowMoreFaqs() {

        $('.component-accordion .accordion').each(function () {

            var $accordion = $(this);
            var $items = $accordion.find('> .accordion-item');

            function initFaqs() {

                if ($(window).width() < 768) {

                    if ($items.length <= 5) {
                        $items.show();
                        $accordion.find('.show-more-wrapper, .show-less-wrapper').remove();
                        return;
                    }

                    $items.slice(5).hide();

                    $accordion.find('.show-more-wrapper, .show-less-wrapper').remove();

                    $('<div class="show-more-wrapper">' +
                        '<a href="#" class="show-more-link">Show More <i class="fa fa-chevron-down" aria-hidden="true"></i></a>' +
                      '</div>')
                        .insertAfter($items.eq(4));

                } else {

                    $items.show();
                    $accordion.find('.show-more-wrapper, .show-less-wrapper').remove();
                }
            }

            $accordion.off('click.componentAccordion');

            $accordion.on('click.componentAccordion', '.show-more-link', function (e) {
                e.preventDefault();

                $items.show();

                $(this).closest('.show-more-wrapper').remove();

                $('<div class="show-less-wrapper">' +
                    '<a href="#" class="show-less-link">Show Less <i class="fa fa-chevron-up" aria-hidden="true"></i></a>' +
                  '</div>')
                    .appendTo($accordion);
            });

           $accordion.on('click.componentAccordion', '.show-less-link', function (e) {
    e.preventDefault();

    var $anchorItem = $items.eq(4);

    $items.slice(5).hide();

    $items.slice(5).find('.accordion-collapse')
        .removeClass('show');

    $items.slice(5).find('.accordion-button')
        .addClass('collapsed')
        .attr('aria-expanded', 'false');

    $(this).closest('.show-less-wrapper').remove();

    var $showMore = $(
        '<div class="show-more-wrapper">' +
            '<a href="#" class="show-more-link">Show More <i class="fa fa-chevron-down" aria-hidden="true"></i></a>' +
        '</div>'
    ).insertAfter($anchorItem);

    $('html, body').animate({
        scrollTop: $showMore.offset().top - 20
    }, 300, function () {
        $showMore.find('.show-more-link').trigger('focus');
    });
});

            initFaqs();

            $(window)
                .off('resize.componentAccordion')
                .on('resize.componentAccordion', function () {
                    initFaqs();
                });

        });
    }

    return {
        ShowMoreFaqs: ShowMoreFaqs
    };

})(jQuery);

$(function () {
    App.ComponentAccordion.ShowMoreFaqs();
});